<template>
  <div class="socials">
    <div class="socials__label">
      <span>Follow Us</span>
    </div>
    <div class="socials__container">
      <a
        class="social social--instagram"
        data-apollo-hover
        data-apollo-hover-animation="scale-center"
        href="https://instagram.com/zoninprosecco"
        target="_blank"
      >
        <span class="mobile-hidden">Instagram</span>
        <span class="desktop-hidden">Ig</span>
      </a>
      <div class="social social__separator">
        <span>&nbsp;&nbsp;.&nbsp;&nbsp;</span>
      </div>
      <a
        class="social social--facebook"
        data-apollo-hover
        data-apollo-hover-animation="scale-center"
        href="https://facebook.com/ZoninProseccoAU"
        target="_blank"
      >
        <span class="mobile-hidden">Facebook</span>
        <span class="desktop-hidden">Fb</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Socials',
};
</script>

<style lang="scss" scoped>
.socials {
  color: $color-dark;
  font-size: rem(22px);
  font-size: $font-size-text;

  display: flex;

  &__container {
    display: flex;
  }

  &__label {
    margin-right: calc((100vw / 32) * 1);
    color: $color-gray;
  }

  .social {
    position: relative;
    @extend %bottom-line;
    color: pointer;
  }
}
</style>
